<template lang="pug">
.charity-bar(@click="setShowCharityPopup(true)")
  img(src="~assets/charity-bar.png")
  .copy
    .line 购买成功支付宝将以你的名义
    .line
      span 为加油木兰计划捐赠
      span.money {{money}}元
  
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  name: 'CharityBar',
  props: {
    money: {},
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    ...mapMutations('app', ['setShowCharityPopup']),
  },
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.charity-bar
  pointer-events: all
  position: relative
  width: 100%
  display: flex
  align-items: center
  justify-content: center
  img
    width: 100%
    object-fit: contain
  .copy
    position: absolute
    left: 35%
    font-size: 12px
    color: black
    .money
      position: relative
      left: 5px
      font-size: 14px
      color: red
</style>
